import { render, staticRenderFns } from "./_UserDialog.vue?vue&type=template&id=37d1696b&scoped=true&"
import script from "./_UserDialog.vue?vue&type=script&lang=js&"
export * from "./_UserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1696b",
  null
  
)

export default component.exports